// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3l2NI","col":"Table_col__zDPGC","fulfillmentStatus":"Table_fulfillmentStatus__3ikaX","emailCol":"Table_emailCol__1xSZh"};